import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { DataMapName } from '@wix/thunderbolt-becky-types'
import { Catharsis } from '../types/catharsis.types'

export const singleTransaction = (
	catharsis: Catharsis,
	beckyModel: BeckyModel,
	usedDataMaps: Iterable<DataMapName>,
	runAndReport: <T>(fn: () => T, name: string) => T
) => {
	const { structure, data, shapeStore, builderPresetsStore, ...environment } = beckyModel

	runAndReport(
		() =>
			catharsis.transaction(
				({ updateStructure, updateData, updateSvgString, updatePresetCss, updateEnvironment }) => {
					runAndReport(() => updateEnvironment(environment), 'catharsis-updateEnvironment')

					runAndReport(() => {
						for (const shapeId in shapeStore) {
							updateSvgString(shapeId, shapeStore[shapeId])
						}
					}, `catharsis-updateSvgString`)

					runAndReport(() => {
						for (const widgetId in builderPresetsStore) {
							const widgetPresets = builderPresetsStore[widgetId]
							updatePresetCss(widgetId, widgetPresets)
						}
					}, `catharsis-updatePresets`)
					runAndReport(() => {
						for (const compId in structure) {
							const comp = structure[compId]
							updateStructure(compId, comp)
						}
					}, `catharsis-updateStructure`)

					runAndReport(() => {
						for (const dataMapName of usedDataMaps) {
							for (const id in data[dataMapName]) {
								const dataItem = data[dataMapName][id]
								updateData(dataMapName, id, dataItem)
							}
						}
					}, `catharsis-updateData`)
				},
				runAndReport
			),
		'catharsis.transaction'
	)
}
